module.exports = __webpack_public_path__ + "static/media/Ettercap.6399cff7.png";